export function getStarsInfo(environment: string | undefined) {
  const isMilkenOrHbas = environment === "ml" || environment === "hbas";
  return [
    {
      label: "Highly Recommended",
      color: "green",
    },
    {
      label: "Definitely Consider",
      color: "yellow",
    },
    {
      label: isMilkenOrHbas ? "Insufficient Data Points" : "Not Ideal",
      color: "salmon",
    },
  ];
}
